import { render, staticRenderFns } from "./StoppedOrder.vue?vue&type=template&id=5b8e3d38&scoped=true&"
import script from "./StoppedOrder.vue?vue&type=script&lang=js&"
export * from "./StoppedOrder.vue?vue&type=script&lang=js&"
import style0 from "./StoppedOrder.vue?vue&type=style&index=0&id=5b8e3d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e3d38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8e3d38')) {
      api.createRecord('5b8e3d38', component.options)
    } else {
      api.reload('5b8e3d38', component.options)
    }
    module.hot.accept("./StoppedOrder.vue?vue&type=template&id=5b8e3d38&scoped=true&", function () {
      api.rerender('5b8e3d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/Ukraine/View/StoppedOrder.vue"
export default component.exports